import { FD_IMAGE_URL } from '../../../constants'
import { FTUXType } from '../../../types/fd-ftux.types'

export const equityFTUX: FTUXType = [
  [
    {
      type: 'TEXT',
      text: `That’s great! You invest in equity`,
      className: 'text-[#D1ECFF] text-[20px] font-[400] leading-[150%] pb-3'
    },
    {
      type: 'TEXT',
      text: `Equity builds <br /> wealth but what <br /> protects it?`,
      className: 'text-[36px] font-[500] leading-[130%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `Every portfolio needs <br />
a ‘peace of mind’ fund.`,
      className: 'text-[30px] font-[500] leading-[130%] pb-3'
    },
    {
      type: 'TEXT',
      text: `Essentially an emergency fund – <br />
in case life takes a turn.`,
      className: 'text-[#D1ECFF] text-[18px] font-[400] leading-[140%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `Build an emergency <br /> fund with Power FD`,
      className: 'text-[30px] font-[500] leading-[130%] pb-3'
    },
    {
      type: 'TEXT',
      text: `How much should you set aside?`,
      className: 'text-[#D1ECFF] text-[18px] font-[400] leading-[140%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `6X`,
      className: 'text-[80px] font-[500] leading-[120%]'
    },
    {
      type: 'TEXT',
      text: `of monthly expenses`,
      className: 'text-[30px] font-[500] leading-[130%] pb-3'
    },
    {
      type: 'TEXT',
      text: `So you’re covered in case of job loss, medical needs, or anything unexpected.`,
      className: 'text-[#D1ECFF] text-[18px] font-[400] leading-[140%] px-2'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `What makes
<br /> Power FD the perfect emergency fund?`,
      className: 'text-[32px] font-[500] leading-[120%] pb-8'
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/shield-icon.svg`,
      title: 'It’s safe',
      text: 'Deposits insured up to ₹5L per bank by DICGC',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/flexible-icon.svg`,
      title: 'It’s flexible',
      text: 'Easily withdraw your investment anytime',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/grows-money-icon.svg`,
      title: 'It grows your money',
      text: 'Earn up to 8.15% returns',
      className: 'w-full px-5',
      isActionable: false
    }
  ],
  [
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/equity-graph.svg`,
      maxWidth: '335px',
      className: 'pb-4'
    },
    {
      type: 'TEXT',
      text: `Equity builds wealth, <br /> Power FD adds stability`,
      className: 'text-[30px] font-[500] leading-[130%] pb-2'
    },
    {
      type: 'TEXT',
      text: `Your portfolio needs both.`,
      className: 'text-[#D1ECFF] text-[18px] font-[400] leading-[140%] px-2'
    }
  ]
]
